export const Constants = {
  TAG_NAME: 'pop-summary-search-component',
  DATA_SUMMARY_SEARCH_PLACEHOLDER: 'data-summary-search-placeholder',
  SUMMARY_SEARCH_INPUT: '.summary-search-input',
  SEARCH_RESULTS: '.search-results',
  SEARCH_RESULTS_LINK: '.search-results-link',
  FUND_MANAGERS: 'fundmanagers',
  CLICK: 'click',
  SELF: '_self',
  LOCAL_HOST_450: 'localhost:450',
  AUTHOR_TROWEPRICE: 'author-troweprice',
  AEM_AUTHOR: 'aem-author',
  CONTENT_FAI: '/content/fai',
  FINANCIAL_INTERMEDIARY: '/financial-intermediary',
  FIRST_CAPTURE_GROUP: '\\$1',
} as const;
